import React from "react";

const Birthday = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8182 9.27314L8.78032 10.0307L5.93214 9.44214L3.016 10.0307L0 9.26959V8.86364C0 8.39348 0.186769 7.94258 0.51922 7.61013C0.851671 7.27768 1.30257 7.09091 1.77273 7.09091H10.0455C10.5156 7.09091 10.9665 7.27768 11.299 7.61013C11.6314 7.94258 11.8182 8.39348 11.8182 8.86364V9.27314ZM11.8182 10.4922V13H0V10.4886L2.98823 11.242L5.92977 10.6488L8.801 11.242L11.8182 10.4922ZM4.13636 5.31818H7.68182V6.5H4.13636V5.31818ZM5.90909 4.96364C5.43893 4.96364 4.98803 4.77687 4.65558 4.44442C4.32313 4.11197 4.13636 3.66107 4.13636 3.19091C4.13636 2.53795 4.72727 1.47432 5.90909 0C7.09091 1.47432 7.68182 2.53795 7.68182 3.19091C7.68182 3.66107 7.49505 4.11197 7.1626 4.44442C6.83015 4.77687 6.37925 4.96364 5.90909 4.96364Z"
        fill="white"
      />
    </svg>
  );
};

export default Birthday;
